import { Either, left, right } from 'fp-ts/lib/Either';
import { csosUpmApi, IDeaNumUser, IError, ResponseCSOSHeaders } from '..';
import { compose as lcompose, map as lmap } from 'lodash/fp';
import { pathOr } from 'rambda';
import { v4 as uuidv4 } from 'uuid';

export const getUserRoles =
  (hR: ResponseCSOSHeaders) =>
  ({
    email,
    deaNumber,
    serialNumber,
    firstName,
    lastName,
  }: {
    email: string | null;
    deaNumber: string | null;
    serialNumber: string | null;
    firstName: string | null;
    lastName: string | null;
  }): Promise<Either<IError, IDeaNumUser[]>> =>
    // Promise.resolve({ data: r })
    csosUpmApi(hR)
      .post(`v1/api/team/search`, {
        email,
        deaNumber,
        serialNumber,
        firstName,
        lastName,
      })
      .then(handleUserRolesSuccess)
      .catch(e => left(e as IError));

const handleUserRolesSuccess = lcompose(
  right,
  lmap(a => ({ ...a, key: uuidv4() })),
  pathOr<IDeaNumUser[]>([], 'data')
);

// const r = [
//   {
//     deaInfoId: 155461,
//     userProfileId: 372,
//     role: 'PRN',
//     firstName: 'CSOS',
//     lastName: 'USER3',
//     loginEmail: 'CSOS.USER3@MYACUITY.COM',
//     deaNumber: 'AB0020777',
//     serialNumber: 'C2022042715294937200001',
//   },
//   {
//     deaInfoId: 155462,
//     userProfileId: 372,
//     role: 'PRN',
//     firstName: 'CSOS',
//     lastName: 'USER3',
//     loginEmail: 'CSOS.USER3@MYACUITY.COM',
//     deaNumber: 'BB00207772',
//     serialNumber: 'C2022042715294937200001',
//   },
//   {
//     deaInfoId: 155463,
//     userProfileId: 372,
//     role: 'PRN',
//     firstName: 'CSOS',
//     lastName: 'USER3',
//     loginEmail: 'CSOS.USER3@MYACUITY.COM',
//     deaNumber: 'CB0020777',
//     serialNumber: 'C2022042715294937200001',
//   },
//   {
//     deaInfoId: 155464,
//     userProfileId: 372,
//     role: 'PRN',
//     firstName: 'CSOS',
//     lastName: 'USER3',
//     loginEmail: 'CSOS.USER3@MYACUITY.COM',
//     deaNumber: 'DB0020777',
//     serialNumber: 'C2022042715294937200001',
//   },
//   {
//     deaInfoId: 155465,
//     userProfileId: 372,
//     role: 'PRN',
//     firstName: 'CSOS',
//     lastName: 'USER3',
//     loginEmail: 'CSOS.USER3@MYACUITY.COM',
//     deaNumber: 'EB0020777',
//     serialNumber: 'C2022042715294937200001',
//   },
// ];
